export default __webpack_public_path__ + "static/media/puppyLittersBanner.2841c736.jpeg";